import axios from 'axios';
import config from '../config/api';

const API_BASE_URL = config.endpoints.sociasRequisitos;

const sociasRequisitosService = {
  async listBySocia(sociaId) {
    const url = `${API_BASE_URL}/requisitos/${encodeURIComponent(sociaId)}`;
    const res = await axios.get(url);
    // El backend devuelve una lista de objetos con REQUISITOS_NOMBRE; devolvemos tal cual
    return Array.isArray(res?.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
  },

  async addRequisito(sociaId, requisitoId) {
    const url = `${API_BASE_URL}/crear/requisito`;
    const body = { socia_id: sociaId, requisito_id: requisitoId };
    const res = await axios.post(url, body);
    return res?.data || { ok: true };
  },

  async removeRequisito(sociaId, requisitoId) {
    const url = `${API_BASE_URL}/eliminar/requisito/${encodeURIComponent(sociaId)}/${encodeURIComponent(requisitoId)}`;
    const res = await axios.delete(url);
    return res?.data || { ok: true };
  }
};

export default sociasRequisitosService;
